import React from 'react';
import { connect } from 'react-redux'
import leftArrow from '../assets/icon_left_arrow.png'
import { goCloseNative, enableCapture} from '../actions/actions-factory'
import { ModalClose } from '../components'

class HeaderBar extends React.Component {
    state = {
		showNotif: false,
		confirmIsOpen: false,
		textHeader: '',
		type: '',
		textReason: '',
		tokenStatus: false,
	}

    componentDidMount() {}
    
    goBack() {
		const { history, pathname, goCloseNative } = this.props

		switch (pathname) {
			case "/":
					goCloseNative()
			break;
			case "/term-condition":
				this.props.history.goBack();
			break;
			case "/pin":
                history.push({pathname: "/term-condition"})
                this.props.enableCapture() // ENABLE function sreen capture
			break;
			case "/opsi-otp":
				history.push({pathname: "/pin"})
			break;
			case "/otp":
				history.push({pathname: "/opsi-otp"})
			break;
			default:
				history.go(-1);
			break;
		}
	}
    render() {
        const { pathname, goCloseNative } = this.props
		const { 
			confirmIsOpen,
        } = this.state
        
        return (
            
            <React.Fragment>
                <ModalClose
                    confirmIsOpen={confirmIsOpen}
                    confirmClose={() => this.setState({confirmIsOpen: false})}
                    confirmCloseNative={() => goCloseNative()}
                />

                <nav className="navbar fixed-top navbar-expand-lg navbar-light bg-light" style={{zIndex: "998"}}>
                    <div className="col-12" style={{padding: '0'}}>
                        <div className="row">
                            <div className="col-3 align-self-center" onClick={() => this.goBack()}>
                                { pathname === '/' ? ''
                                :
                                <img src={leftArrow} style={{width: '1.2rem', height: '1.3rem', verticalAlign: 'text-top'}} alt=""/>							
                                }
                            </div>
                            <div className="col-6 text-center align-self-center" style={{fontSize: '16px', fontWeight: '600'}}>
                                { pathname === '/opsi-otp' ? 
                                    'Verifikasi Kode OTP' :
                                    pathname === '/term-condition' ? 'Syarat & Ketentuan' : 'Daftar Akun OttoPay'
                                }
                            </div>
                            <div className="col-3 btn-text-close text-primary align-self-center" onClick={() => this.setState({confirmIsOpen: true})}>
                                Tutup
                            </div>
                        </div>
                    </div>
                </nav>
            </React.Fragment>
        )
    }
  }

export default connect(
	({auth}) => ({auth}),
	{ goCloseNative, enableCapture }
)(HeaderBar);
